<template>
  <t-form labelWidth="80px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm" />
    <CptInputOptionBase
      :attribute="attribute"
      :currentCpt="currentCpt"
      @changeSize="changeSize"
    />
    <e-collapse title="数字类型" :expand="true">
      <t-form-item label="数字类型">
        <t-radio-group size="small" v-model="attribute.numbertype">
          <t-radio-button value="int">整数</t-radio-button>
          <div style="width: 100%">
            <t-radio-button value="zint">正整数</t-radio-button>
          </div>
          <div style="width: 100%">
            <t-radio-button value="fint">负整数</t-radio-button>
          </div>
          <div style="width: 100%">
            <t-radio-button value="bigint">大于等于零整数</t-radio-button>
          </div>
          <div style="width: 100%">
            <t-radio-button value="smallint">小于等于零整数</t-radio-button>
          </div>
          <div style="width: 100%">
            <t-radio-button value="decimal">小数</t-radio-button>
          </div>
          <t-radio-button value="fun">表达式</t-radio-button>
        </t-radio-group>
      </t-form-item>
      <t-form-item label="表达式" v-show="attribute.numbertype == 'fun'">
        <t-textarea
          size="small"
          v-model="attribute.funText"
          placeholder="请输入表达式"
        />
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
import CptData from "@/components/element/options/comp/cpt-data";
import CptInputOptionBase from "@/components/element/options/comp/cpt-input-option-base";
export default {
  name: "cpt-number-option",
  props: {
    attribute: Object,
    cptDataForm: Object,
    currentCpt: Object,
  },
  components: { CptData, CptInputOptionBase },
  created() {
    this.textFamilyList = require("@/assets/font/font-list");
    this.lineTypeList = require("@/assets/data/line-type");
  },
  data() {
    return {
      sizeOptions: {
        small: { width: this.currentCpt.cptWidth, height: 24 },
        medium: { width: this.currentCpt.cptWidth, height: 32 },
        large: { width: this.currentCpt.cptWidth, height: 40 },
      },
    };
  },
  methods: {
    changeSize(val) {
      const sizeAttributes = this.sizeOptions[val];
      if (sizeAttributes) {
        this.attribute.width = sizeAttributes.width;
        this.attribute.height = sizeAttributes.height;
      } else {
        console.warn(`Invalid size option: ${val}`);
      }
    },
  },
};
</script>

<style scoped>
</style>